if (!customElements.get('blog-cta-sticky')) {
  customElements.define(
    'blog-cta-sticky',
    class BlogCtaSticky extends HTMLElement {
      constructor() {
        super();
        this.threshold = (parseInt(this.dataset.scrollTrigger, 10) || 30) / 100;
      }

      connectedCallback() {
        if (sessionStorage.getItem('blogCtaStickyDismissed') === '1') {
          this.hidden = true;
          return;
        }

        this.onScrollHandler = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScrollHandler, { passive: true });
        this.onScroll();

        const closeBtn = this.querySelector('.blog-cta-sticky__close');
        if (closeBtn) {
          closeBtn.addEventListener('click', this.dismiss.bind(this));
        }
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScrollHandler);
      }

      dismiss() {
        this.classList.remove('blog-cta-sticky--visible');
        window.removeEventListener('scroll', this.onScrollHandler);
        try {
          sessionStorage.setItem('blogCtaStickyDismissed', '1');
        } catch (e) {
          /* sessionStorage unavailable — dismissal just won't persist */
        }
        // Remove from layout after the slide-out transition completes.
        setTimeout(() => {
          this.hidden = true;
        }, 300);
      }

      onScroll() {
        const scrollableHeight = document.documentElement.scrollHeight - window.innerHeight;
        if (scrollableHeight <= 0) return;

        const scrolledPercent = window.scrollY / scrollableHeight;

        if (scrolledPercent >= this.threshold) {
          this.classList.add('blog-cta-sticky--visible');
          window.removeEventListener('scroll', this.onScrollHandler);
        }
      }
    }
  );
}
